export function isNotNil<T>(e: T | null | undefined): e is T {
    return e !== null && e !== undefined;
}
